import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSessionStorage } from 'shared';

import { TAP2MINE_REFERRAL_SS_KEY } from '../../constants/key';
import { ITap2MineReferralForm } from '../../types';

export const Tap2MineReferralFormProvider = ({ children }: PropsWithChildren) => {
  const [refCode] = useSessionStorage(TAP2MINE_REFERRAL_SS_KEY, undefined);

  const formObject = useForm<ITap2MineReferralForm>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    shouldFocusError: false,
    defaultValues: {
      refCode,
    },
  });

  return <FormProvider {...formObject}>{children}</FormProvider>;
};
